import { render, staticRenderFns } from "./YoutubeVideo.vue?vue&type=template&id=c97476c6&scoped=true&"
import script from "./YoutubeVideo.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideo.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeVideo.vue?vue&type=style&index=0&id=c97476c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97476c6",
  null
  
)

export default component.exports